import { useTranslation } from 'react-i18next';

import AssetCollapseContext from '@/context/AssetCollapseContext';
import { cn } from '@/utils/styles';

import AllStakeTips from '../tips';
import RestakingForm from './RestakingForm';

const { useAssetCollapseTracked } = AssetCollapseContext;

function MeshedRestakingForm() {
  const { t } = useTranslation();
  const [assetCollapse] = useAssetCollapseTracked();

  return (
    <div
      className={cn(
        'flex flex-col mx-6 gap-5 sm:gap-6 md:gap-8 justify-center items-center',
        assetCollapse ? 'mt-[40px] md:mt-[100px]' : 'mt-[40px]',
      )}
    >
      <div className="flex flex-col gap-2 text-center md:gap-4">
        <div className="text-[28px] md:text-[40px] font-semibold">
          {t('restake.meshedRestakingDeposits')}
        </div>
        <div className="flex items-center justify-center gap-2 text-sm text-white cursor-pointer text-opacity-60 md:text-base">
          {t('restake.depositToEarnRestakedPoints')}
          <AllStakeTips>{t('restake.depositToEarnRestakedPointsTip')}</AllStakeTips>
        </div>
      </div>
      <RestakingForm />
    </div>
  );
}

export default MeshedRestakingForm;
